module.exports = __webpack_public_path__ + "static/media/uki.013c6d82.png";